// @flow
import { createSelector } from "reselect"

import UrlParser from "./UrlParser"
import reverseTranslateSelector from "../intl/reverseTranslateSelector"

// $FlowFixMe
export default createSelector(
  [reverseTranslateSelector],
  reverseTranslate => new UrlParser(reverseTranslate),
)
